export const getActivePushpinAttributes = state => state.issuePushpin.activePushpinAttributes;
export const getPendingPushpinThumbnails = state => state.issueSnapshot.pendingThumbnails;

export const getPushpinWorkflowEnabled = state => state.pushpinWorkflowEnabled;
